export interface Environment {
  environment: 'dev' | 'stage' | 'prod';
  production: boolean;
  appVersion?: string;
  apiEndpoints: Record<string, string>;
  oktaClientId: string;
  sentry: Record<string, string>;
  amplitude: { apiKey: string };
  /** Story Service base URL (e.g. http://localhost:3000). Used by demo step controls. */
  storyServiceBaseUrl?: string;
  /**
   * Optional local override for Story Service base URL when running on localhost/127.0.0.1.
   * Allows dev builds to target deployed Story Service by default while still supporting local testing.
   */
  storyServiceLocalBaseUrl?: string;
  /** Story Service runtime auth key sent as x-demo-key header. */
  storyDemoKey?: string;
  /** Story Service admin auth key sent as x-admin-key header for admin routes. */
  storyAdminKey?: string;
}
